import { useEffect, useState } from "react";

const CHECK_MIN_INTERVAL_MS = 5 * 60 * 1000;
let current = null;
let lastCheck = 0;

const fetchVersion = async () => {
  const r = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
  if (!r.ok) throw new Error("version.json indisponible");
  return (await r.json()).version;
};

export const hardReload = async () => {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
    const reg = await navigator.serviceWorker?.getRegistration?.();
    await reg?.update?.();
  } catch (e) { /* best effort */ }
  const url = new URL(window.location.href);
  url.searchParams.set("v", String(Date.now()));
  window.location.replace(url.toString());
};

export const useAppUpdate = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async (force = false) => {
      if (!force && Date.now() - lastCheck < CHECK_MIN_INTERVAL_MS) return;
      lastCheck = Date.now();
      try {
        const v = await fetchVersion();
        if (cancelled) return;
        if (current === null) current = v;
        else if (v !== current) setUpdateAvailable(true);
      } catch (e) { /* hors-ligne : on réessaiera */ }
    };
    check(true);
    const onVisible = () => { if (document.visibilityState === "visible") check(); };
    window.addEventListener("focus", onVisible);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("pageshow", onVisible);
    const timer = setInterval(() => check(), CHECK_MIN_INTERVAL_MS);
    return () => { cancelled = true; clearInterval(timer); window.removeEventListener("focus", onVisible); document.removeEventListener("visibilitychange", onVisible); window.removeEventListener("pageshow", onVisible); };
  }, []);

  return { updateAvailable, reload: hardReload };
};
